export const PUBLISHED_LESSONS_LIST_PREFIX = 'publishedLessonsList';

export const FETCHED_CURRENT_LESSON =
               `${PUBLISHED_LESSONS_LIST_PREFIX}/fetched_current_lesson`;
